import React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';

import FormError from './FormError';

const getValidationState = meta => {
  if (meta.touched) {
    if (meta.valid === false) {
      return 'error';
    }
    if (meta.warning) {
      return 'warning';
    }
    if (meta.valid === true) {
      // return 'success';
    }
  }

  return null;
};

const getClassInlineCheckbox = (required, disabled) => {
  if (required && disabled) return 'required text-muted';
  if (required) return 'required';
  if (disabled) return 'text-muted';
  return '';
};

const Input = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <FormControl {...input} type={type} {...props} />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const Select = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <FormControl {...input} componentClass="select" {...props} />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const Select2 = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <ReactSelect
        {...props}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
        simpleValue
      />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const Creatable = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <ReactSelect.Creatable
        {...props}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
      />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const InputGroup = (
  {
    input,
    label,
    type,
    meta,
    children,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      {children}
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const InlineCheckbox = (
  {
    input,
    label,
    meta,
    required,
    help,
    className,
    disabled,
    checkBoxProps = {},
    ...props
  }
) => (
  <FormGroup
    controlId={input.name}
    validationState={getValidationState(meta)}
    className={className}
    style={disabled ? { opacity: '.75' } : {}}
  >
    <div className="form-container inline-checkbox">
      <label className="checkbox">
        <FormControl
          {...input}
          type="checkbox"
          {...props}
          disabled={disabled}
        />
        <div className="checkbox-slider" {...checkBoxProps}>
          x
        </div>
      </label>
      {label &&
        <strong className={getClassInlineCheckbox(required, disabled)}>
          {label}
        </strong>}
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

export default {
  Input,
  InputGroup,
  Select,
  Select2,
  Creatable,
  InlineCheckbox
};



// WEBPACK FOOTER //
// ./src/components/forms/FormField.js